export function matchesItemSearch(
  search: string,
  fields: (string | undefined)[],
): boolean {
  const words = search.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;

  const haystack = fields
    .filter((field): field is string => typeof field === "string")
    .join(" ")
    .toLowerCase();

  return words.every((word) => haystack.includes(word));
}
